/**
 *
 */
(function(window) {
    'use strict';

    const VvDownloadSrvc = function() {
        // Converte la stringa di dati a 64 bit in byteArrays
        const b64toByteArrays = (b64Data, sliceSize) => {
            sliceSize = sliceSize || 512;
            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (
                var offset = 0; offset < byteCharacters.length; offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }
            return byteArrays;
        };

        // Genera un oggetto di tipo Blob (per IE) o di tipo File e fa partire il download
        this.download = (strData, fileName) => {
            var byteArrays = b64toByteArrays(strData);

            var isChromium = window.chrome,
                winNav = window.navigator,
                vendorName = winNav.vendor,
                isOpera = winNav.userAgent.indexOf('OPR') > -1,
                isIEedge = winNav.userAgent.indexOf('Edge') > -1,
                isIOSChrome = winNav.userAgent.match('CriOS');
            var blob = null;
            var blobUrl = null;
            if (
                isIOSChrome ||
                (isChromium !== null &&
                    isChromium !== undefined &&
                    vendorName === 'Google Inc.' &&
                    isOpera === false &&
                    isIEedge === false)
            ) {
                // Google Chrome
                blob = new Blob(byteArrays, {
                    type: 'application/octet-stream'
                });
                blobUrl = URL.createObjectURL(blob);
                // soluzione per costringere chrome a mostrare nome ed estensione del file
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = blobUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(fileUrl);
                a.parentNode.removeChild(a);
            } else {
                // non Google Chrome
                // Blob per internet explorer
                if (navigator.msSaveOrOpenBlob) {
                    blob = new Blob(byteArrays, {
                        type: 'application/octet-stream'
                    });
                    blobUrl = URL.createObjectURL(blob);
                    navigator.msSaveOrOpenBlob(blob, fileName);
                } // File per altri browser
                else {
                    var file = new File(byteArrays, fileName, {
                        type: 'application/octet-stream;'
                    });
                    var fileUrl = URL.createObjectURL(file);
                    window.open(fileUrl);
                }
            }
        };
    };

    VvDownloadSrvc.$inject = [];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomDownloadSrvc', VvDownloadSrvc);
})(window);